import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { UserCard } from "components/UserCard/UserCard.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { WEB_URL } from "variables/Variables.jsx";
import avatar from "assets/img/faces/face-3.jpg";
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";
import qs from 'query-string';

class ConfirmEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
        ConfirmCode : '',
        AccountPassword : '',
        UserName : '',
        runningUpdatePasswordOperation : false
    }
  }

  componentDidMount () {
      var params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
      this.setState({ConfirmCode : params.confirmation_code, UserName : params.user_name });
  }

  handleUserInput (e) {
        const name = e.target.name;
        const value = e.target.value;
        const targetField = e.target;
    
        this.setState({[name]: value});
  }

  handlePasswordUpdate(e){

    var _this = this;
    this.setState({runningUpdatePasswordOperation : true});


    fetch("https://"+WEB_URL+"/account/api/confirmemail",{
        'method' : 'POST',
        'headers' : { 'Content-Type' : 'application/json'},
        'body' : JSON.stringify({confirmation_code : _this.state.ConfirmCode, user_name : _this.state.UserName, password : _this.state.AccountPassword})
        }).then(res => res.json())
        .then(
            (response) => {
            if(response.result == 'FAILURE'){
                this.props.triggerNotification('error','tc',response.message);
            }else{
                this.props.triggerNotification('success','tc','Successfully confirmed your email.');

                this.props.history.push('/home/login');
            }

            this.setState({runningUpdatePasswordOperation : false});
            },
            (error) => {
            this.setState({runningUpdatePasswordOperation : false});
            }
        )


    e.preventDefault();
  }

  render() {
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={8}>
              <Card
                title="Enter account password to confirm your email address"
                content={
                  <form>
                    <Row style={{paddingBottom:15}}>
                    <Col md={12} style={{paddingRight:7}}>
                    {<FormInputs
                      ncols={["col-md-6", "col-md-6"]}
                      properties={[
                        {
                            label: "Confirmation Code",
                            type: "text",
                            name: "ConfirmCode",
                            bsClass: "form-control",
                            placeholder: "",
                            defaultValue: this.state.ConfirmCode
                        },
                        {
                          label: "Account Password",
                          type: "password",
                          name: "AccountPassword",
                          bsClass: "form-control",
                          placeholder: "Account Password",
                          defaultValue: ""
                        }
                      ]}
                      onChange={(event) => this.handleUserInput(event)} 
                    /> }
                    </Col>
                    </Row>

                    <ProgressButton runningAsyncOperation={this.state.runningUpdatePasswordOperation}  onClick={(e) => {this.handlePasswordUpdate(e);}} bsStyle="info" fill type="submit">
                      Confirm Email Address
                    </ProgressButton>

                    <Button bsStyle="default pull-right" fill type="submit"  onClick={(e) => this.props.history.push('/home/user')}>
                      Cancel
                    </Button>
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default ConfirmEmail;
